import {CharacterType} from '../redux/slices/character/characterType';

export enum NotificationTypes {
    "Success",
    "Error",
    "Info"
}

export const emptyCharacter: CharacterType = {
    characterName: '',
    characterId: 0,
    characterLevel: 0,
    characterExp: 0,
    character_to_class: [],
    Race: {
        raceId: 0,
        raceName: "",
        raceDescription: "",
        raceFeatures: []
    },
    Subrace: {
        subraceDescription: "",
        subraceId: 0,
        subraceName: "",
        subraceFeatures: []
    },
    CharacterSheet: {
        characterSheetId: 0,
        initiative: 0,
        armorClass: 0,
        lifepoints: 0,
        temporaryHitpoints: 0,
        currentHitpoints: 0,
        spellSaveDc: 0,
        currentMana: 0,
        spellAttackModifier: 0,
        silver: 0,
        gold: 0,
        languages: "",
        ability_to_characterSheet: [],
        skill_to_characterSheet: [],
        Spell: [],
        Note: [],
        Item: []
    },
}

export interface DropdownEntry {
    itemValue: number,
    itemText: string,
}